import React from 'react';
import pt from 'prop-types';
import { imageUrl } from 'utils';
import './apps.scss';

export default function AppImages({ images }) {
  return (
    <div className="apps-screenshots">
      {images.map((image) => {
        const imageFile = image.image || image.file || image;

        return (
          <a
            key={image.id || imageFile?.filename || imageFile?.url}
            className="apps-screenshot"
            href={imageFile?.url}
            target="blank"
          >
            <img
              src={imageUrl(imageFile?.url, { width: 400, height: 300 })}
              alt={imageFile?.title || imageFile?.filename || ''}
            />
          </a>
        );
      })}
    </div>
  );
}

AppImages.propTypes = {
  images: pt.array.isRequired,
};
